import { $api } from "../generated/client";

type ProductsListParams = {
	shopId: string;
};

export default function useAnalyticsProductsList({
	shopId,
}: ProductsListParams) {
	return $api.useQuery("get", "/shops/{shopId}/analytics/products", {
		params: {
			path: { shopId },
			query: {
				/**
				 * TODO: GUILLAUME from 4 months ago to now by default ?
				 */
				fromTimestamp: Math.floor(
					new Date(Date.now() - 4 * 30 * 24 * 60 * 60 * 1000).getTime() / 1000,
				),
				toTimestamp: Math.floor(Date.now() / 1000),
			},
		},
	});
}
